var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAddUser = function SvgIcAddUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.458 16.863V15.34c0-.809-.323-1.584-.899-2.156a3.081 3.081 0 0 0-2.171-.893H5.015c-.815 0-1.596.321-2.171.893a3.038 3.038 0 0 0-.9 2.156v1.524m14.585-9.91v4.574m2.303-2.286h-4.606m-3.454-3.05c0 1.684-1.375 3.05-3.07 3.05-1.696 0-3.071-1.365-3.071-3.05 0-1.683 1.375-3.049 3.07-3.049 1.696 0 3.07 1.366 3.07 3.05Z"
  })));
};
export default SvgIcAddUser;